module.exports = __webpack_public_path__ + "img/404.935aad20.svg";